import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

/**
 * @param {string} customName
 * @returns {Promise<{ customName: string | null }>}
 */
export const updateCustomMyQuotesName = async customName => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const payload = { name: customName };
    const response = await axios.put(`${API_URL}/company/myquotes/customName`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};
